import { apiClient } from "helpers/api_helper"

export const getAllStyleMasterDataData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/StylesMaster/GetAllStyleMaster`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};